import * as React from 'react'

export const footer = () => {
  return (
    <footer id="a11y-footer" className="footer">
      <div className="footer__inner container container--m grid--gutter">
        {/* giusto */}
        <div className="footer__logo">
          <a href="">
           <img src="/images/logo-new-refresco.svg" alt="Refresco logo" width="200" height="33" />
          </a>
        </div>
        <nav className="nav nav--footer">
          <ul className="nav__list">
            <li className="nav__item">
              <a href="" className="nav__link">
                Security
              </a>
            </li>
            <li className="nav__item">
              <a href="" className="nav__link">
                Sustainability
              </a>
            </li>
            <li className="nav__item">
              <a href="" className="nav__link">
                System integration
              </a>
            </li>
            <li className="nav__item">
              <a href="" className="nav__link">
                Aesthetic On-Trend Design
              </a>
            </li>
            <li className="nav__item">
              <a href="" className="nav__link">
                Reliability and Durability
              </a>
            </li>
          </ul>
        </nav>
      </div>
      <div className="footer__copyright"  id="a11y-footer-copyright">
        ® Refresco UK 2026
      </div>
    </footer>
  )
}
